import axios, { AxiosError } from "axios";
import * as Sentry from "@sentry/react";

let api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL || "http://localhost:3000/api",
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("duas-vidas-token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Normaliza o caminho para agrupar erros no Sentry: /recursos/abc-123 e
// /recursos/def-456 sao a MESMA falha — sem isto viram grupos distintos no
// painel (e estouram o limite de cardinalidade das tags).
function endpointPattern(endpoint: string): string {
  return endpoint
    .split("?")[0]
    .replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
      "/:id"
    )
    .replace(/\/\d+/g, "/:id");
}

// Nem toda resposta HTTP de erro deve virar evento — so 5xx (falha real do
// servidor) e falha de rede. 4xx (validacao, permissao, sessao expirada) e
// uso esperado e nao deve poluir o painel. Sem DSN configurado, as chamadas
// abaixo sao no-op (ver src/instrument.ts).
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const method = (error.config?.method || "unknown").toUpperCase();
    const endpoint = error.config?.url || "unknown";
    const pattern = endpointPattern(endpoint);
    const status = error.response?.status;

    if (status === undefined) {
      // Sem response = falha de rede/timeout/CORS, nao um status HTTP.
      Sentry.withScope((scope) => {
        scope.setTag("api_endpoint", pattern);
        scope.setTag("api_status", "network_error");
        scope.setContext("request", { method, endpoint });
        Sentry.captureException(
          error instanceof Error ? error : new Error(`Falha de rede em ${method} ${pattern}`)
        );
      });
    } else if (status >= 500) {
      Sentry.withScope((scope) => {
        scope.setTag("api_endpoint", pattern);
        scope.setTag("api_status", String(status));
        scope.setContext("request", { method, endpoint, status });
        Sentry.captureException(new Error(`API ${status} ${method} ${pattern}`));
      });
    }
    // status < 500: erro de negocio esperado, nao reportar.

    return Promise.reject(error);
  }
);

export default api;
